export const HIVE_API_BASE_URL = "http://192.168.8.70:4567/api/";
export const API_ACTION_HIVE_STATUS = "server";
export const API_ACTION_AGV_STATUS = "agvs";

export function ComposeUri(baseAddress, action){
    return baseAddress + action;
}